import * as React from 'react';
export class LayoutRenderer extends React.PureComponent {
    render() {
        switch (this.props.layout.type) {
            case 'column':
                return this.renderColumn(this.props.layout);
            case 'row':
                return this.renderRow(this.props.layout);
            case 'stack':
                return this.renderStack(this.props.layout);
        }
    }
    renderColumn(column) {
        return React.createElement(this.props.floatyRenderers.columnRenderer, { floatyRenderers: this.props.floatyRenderers, floatyManager: this.props.floatyManager, column: column });
    }
    renderRow(row) {
        return React.createElement(this.props.floatyRenderers.rowRenderer, { floatyRenderers: this.props.floatyRenderers, floatyManager: this.props.floatyManager, row: row });
    }
    renderStack(stack) {
        return React.createElement(this.props.floatyRenderers.stackRenderer, { floatyRenderers: this.props.floatyRenderers, floatyManager: this.props.floatyManager, stack: stack });
    }
}
//# sourceMappingURL=layout-renderer.js.map